export const BATTERY_SAVINGS_INPUT_LABEL = `Use Green Button grid data for battery savings only.`

export const BATTERY_SAVINGS_INPUT_HELP = `This does not replace the proposal's household consumption.`

export const BATTERY_SAVINGS_INPUT_UNAVAILABLE = `Green Button grid data is not available for Battery savings yet.`

export const savingsInputUnavailableCopy = (reason: string | null): string => {
  switch (reason) {
    case `incomplete_consumption_profile`:
      return `Green Button grid data does not yet include a complete measured year.`
    case `measured_intervals_incomplete`:
      return `Measured usage does not cover a full year.`
    case `measured_intervals_imputed`:
      return `Some measured readings were filled in, so they cannot drive Battery savings yet.`
    case `measured_channels_ambiguous`:
      return `The meter channels do not clearly distinguish grid imports from exports.`
    default:
      return BATTERY_SAVINGS_INPUT_UNAVAILABLE
  }
}
